module.exports = __webpack_public_path__ + "img/Robbi_Plug.c9f0d5cc.png";